import {
  signetStatesАrray,
  signetStatusArray,
} from '../../../constants/globals';

export const config = (translations, enums) => {
  const { plannedStartFrom, plannedStartTo, uniqueSerialNumber } =
    translations || {};
  const { SignetState, SignetStatus } = enums || {};

  return {
    fields: [
      {
        key: 5,
        name: 'requestForSignetApproval',
        type: 'text',
        label: 'requestForSignetApproval',
        component: 'input',
      },
      {
        key: 6,
        name: 'uniqueSerialNumber',
        type: 'text',
        label: uniqueSerialNumber,
        component: 'input',
      },
      {
        key: 2,
        name: 'signetState',
        type: 'autocomplete',
        optionList: signetStatesАrray,
        getOptionLabel: (state) => SignetState[state.constant]?.text || '',
      },
      {
        key: 1,
        name: 'signetStatus',
        type: 'autocomplete',
        optionList: signetStatusArray,
        getOptionLabel: (status) => SignetStatus[status.constant]?.text || '',
      },
      {
        key: 3,
        name: 'plannedStartFrom',
        type: 'date',
        label: plannedStartFrom,
        component: 'input',
      },
      {
        key: 4,
        name: 'plannedStartTo',
        type: 'date',
        label: plannedStartTo,
        component: 'input',
      },
      {
        key: 5,
        name: 'submitDateFrom',
        type: 'date',
        label: 'submitDateFrom',
      },
      {
        key: 6,
        name: 'submitDateTo',
        type: 'date',
        label: 'submitDateTo',
      },
    ],
  };
};
